import { jsx as n, jsxs as s, Fragment as i } from "react/jsx-runtime";
import a from "../../../icons/CheckmarkThin.js";
import m from "../../../icons/Dropdown.js";
import f from "../../../icons/LoadingCircleBold.js";
import u from "../../Checkbox/index.js";
const l = (
  /* dropdownWidth === true ? 0 : */
  1
), x = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 0],
    overflow: { adjustX: l, adjustY: 1 },
    htmlRegion: "scroll"
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 0],
    overflow: { adjustX: l, adjustY: 1 },
    htmlRegion: "scroll"
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, 0],
    overflow: { adjustX: l, adjustY: 1 },
    htmlRegion: "scroll"
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, 0],
    overflow: { adjustX: l, adjustY: 1 },
    htmlRegion: "scroll"
  }
}, v = (e, r) => r ? /* @__PURE__ */ n(
  u,
  {
    name: "option_chkbox",
    containerClass: "rc-select-option-checkbox",
    iconClass: "rc-select-option-checkbox-icon",
    viewStyle: "square",
    size: "medium",
    checked: e
  }
) : e ? /* @__PURE__ */ n(a, { className: "rc-select-option-checkmark" }) : null, k = (e, r, o) => e ? /* @__PURE__ */ n(f, { className: "rc-select-loader-icon" }) : /* @__PURE__ */ s(i, { children: [
  o,
  r && /* @__PURE__ */ n(m, { className: "rc-select-arrow-icon" })
] }), w = (e) => e ? /* @__PURE__ */ s("span", { className: "rc-select-selection-count", children: [
  "+",
  e.length
] }) : null, R = (e, r, o, t) => r.findIndex(({ value: c }) => c === e.value) === -1 && (!o || o.findIndex(({ value: c }) => c === e.value) === -1) && (!Array.isArray(t) || !t.includes(e.value)) ? `Добавить "${e.label}"` : e.label, j = (e, r, o, t) => /* @__PURE__ */ s("div", { ref: r, children: [
  e,
  o && /* @__PURE__ */ n("div", { onMouseUp: t, children: o })
] }), C = ({ creatable: e, multiple: r, readOnly: o, loadingUrl: t }) => {
  if (r)
    return !o && e ? "tags" : "multiple";
  if (!o && (t || e))
    return "combobox";
};
export {
  x as builtinPlacements,
  j as dropdownRender,
  C as getSelectMode,
  w as maxTagPlaceholder,
  v as menuItemSelectedIcon,
  R as optionRender,
  k as suffixIcon
};
